<template>
  <div>
    <!-- header -->
    <header class="homepage-header" :class="{ fixed: navFixed }">
      <div class="homepage-header-container">
        <div class="homepage-header-left">
          <div class="homepage-header-logo">
            <img
              v-if="bannerIndex === 2 && !navFixed"
              class="homepage-header-logo--logo logo1"
              src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/logo1.png"
              alt="logo"
            />
            <img
              v-else
              class="homepage-header-logo--logo logo2"
              src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/logo2.png"
              alt="logo"
            />
          </div>
          <nav
            class="homepage-header-nav"
            :class="{
              'homepage-header-nav--white': bannerIndex === 2 && !navFixed,
            }"
          >
            <a data-target="#home" class="homepage-header-nav-item">首页</a>
            <a
              href="/#/download"
              target="_blank"
              class="homepage-header-nav-item"
            >
              下载APP
            </a>
            <a
              href="https://html.renrenjiang.cn/document"
              target="_blank"
              class="homepage-header-nav-item"
            >
              使用教程
            </a>

            <a
              href="http://ke.renrenjiang.cn"
              target="_blank"
              class="homepage-header-nav-item"
            >
              学员听课入口
            </a>
          </nav>
        </div>

        <div class="homepage-header-right">
          <a
            href="https://dy.renrenjiang.cn/#/dashboard"
            class="homepage-header-top-btn homepage-header-top-teacher-btn"
            target="_blank"
          >
            讲师登录
          </a>
          <a
            href="https://dy.renrenjiang.cn/#/login?from=homepage"
            class="homepage-header-top-btn homepage-header-top-open-btn"
          >
            免费开通
          </a>
        </div>
      </div>
    </header>
    <!-- banner -->
    <el-carousel
      class="banner-box"
      height="493px"
      :autoplay="true"
      :interval="5000"
      @change="changeBanner"
    >
      <el-carousel-item>
        <div class="home-banner">
          <div class="home-layout">
            <div class="home-banner-content">
              <div class="home-banner-title">人人讲</div>
              <div class="home-banner-title">
                <span>免费的</span>
                <span>多平台知识服务平台</span>
              </div>
              <div class="home-banner-tip">
                公域：抖音、视频号、小红书、快手一键上架课程
              </div>
              <div class="home-banner-tip">
                私域：微信H5、小程序、网校，直播授课转化
              </div>
            </div>
            <img
              src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_banner_right.png"
            />
          </div>
          <!-- <img src="https://renrenjiang.cn/home/img/page/111.jpg" /> -->
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="home-banner home-banner-3">
          <div class="home-layout">
            <div class="home-banner-content">
              <div class="home-banner-title">抖音、视频号、小红书、快手</div>
              <div class="home-banner-title">
                <span>一键上架课程</span>
              </div>
              <div class="home-banner-tip">不用发货，没有年费，免费入驻</div>
              <div class="home-banner-tip">直播、短视频都可直接挂载卖课</div>
            </div>
            <img
              src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_banner_right_3.png"
            />
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="home-banner home-banner-2">
          <div class="home-layout">
            <div class="home-banner-content">
              <div class="home-banner-title">
                微信小程序、H5网校，一键快速搭建
              </div>
              <!-- <div class="home-banner-title">专属微信小程序/H5知识店铺</div> -->
              <div class="home-banner-tip">
                <span>全域获课 | 私域转化 | SCRM用户管理系统</span>
              </div>
              <div class="home-banner-info">
                <span>私域直播授课，多种营销转化玩法</span>
              </div>
              <div class="home-banner-info">
                <span>支持直播、连麦、打卡、点评等深度链接用户</span>
              </div>
            </div>
            <img
              src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_banner_right_2.png"
            />
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- 内容 -->
    <div class="home-layout">
      <div class="home-header pt-100">免费的多平台课程服务工具</div>

      <div class="home-desc pt-25">
        为所有内容创作者提供公域+私域的课程售卖解决方案
        <br />
        100,000+机构/个人都在用人人讲售卖课程
      </div>

      <div class="home-tool-section">
        <div class="home-tool-item">
          <img
            src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_tool_1.png"
          />
          <div>
            <div v-if="numFixed" class="home-tool-item-num">
              <count-to
                :startVal="0"
                :endVal="100000"
                :duration="1000"
              ></count-to>
            </div>
            <div v-else class="home-tool-item-num">100,000</div>
            <div>讲师信赖人人讲</div>
            <!-- 人人讲授课 -->
          </div>
        </div>
        <div class="home-tool-item">
          <img
            src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_tool_2.png"
          />
          <div>
            <div v-if="numFixed" class="home-tool-item-num">
              <count-to
                :startVal="0"
                :endVal="1000000"
                :duration="1000"
              ></count-to>
            </div>
            <div v-else class="home-tool-item-num">1000,000</div>
            <div>讲师入驻平均年入超百万</div>
          </div>
        </div>
        <div class="home-tool-item">
          <img
            src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_tool_3.png"
          />
          <div>
            <div v-if="numFixed" class="home-tool-item-num">
              <count-to :startVal="0" :endVal="20" :duration="1000"></count-to>
              w+
            </div>
            <div v-else class="home-tool-item-num">20w+</div>
            <div>课程，打造全面学习体验</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 达人 -->
    <div class="home-header">行业头部达人，都在使用人人讲</div>
    <div class="rotation-center">
      <ul>
        <li v-for="item in 10" :key="item">
          <img
            :src="`https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_person_${
              item + 1
            }.png`"
          />
        </li>
        <li v-for="item in 10" :key="item + '_1'">
          <img
            :src="`https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_person_${
              item + 1
            }.png`"
          />
        </li>
      </ul>
      <div class="teacher-list">
        <div class="teacher-item" v-for="demo in demos" :key="demo.id">
          <div class="teacher-item-img">
            <img :src="demo.avatar" />
          </div>
          <div class="demo-item-nickname">{{ demo.nickname }}</div>
          <div class="demo-item-desc">{{ demo.desc }}</div>
        </div>
      </div>
    </div>

    <!-- 全域支持 -->
    <div class="home-header">想不想让你的课程全网卖爆，吸引更多学员？</div>
    <div class="home-desc pt-25">
      抖音、快手、视频号、小红书、微信私域全部支持
    </div>
    <div class="home-channel"></div>

    <div class="home-header">一键操作，完成课程上架销售和交付全流程</div>
    <div class="home-shelf"></div>

    <!-- 提供内容变现能力，助力品牌IP打造 -->
    <div class="home-section home-section-1">
      <div class="home-header">提供内容变现能力，助力品牌IP打造</div>
      <div class="home-desc pt-25">
        实现公域获客-直播营销-课程交付-用户运营的全链路经营
      </div>
      <div class="product-info-content-item home-layout">
        <img
          class="product-info-content-img"
          src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_section_1.png"
        />
        <div class="product-info-content-item-view">
          <div class="product-info-header">多平台</div>
          <div class="product-info-desc">
            支持在抖音、视频号、小红书、微信私域、快手等多平台同时售卖课程，统一进行管理
          </div>
          <div class="product-info-header">免费</div>
          <div class="product-info-desc">
            免费即可开通使用，不收年费，没有试错成本
          </div>
          <div class="product-info-header">手机端一键上架</div>
          <div class="product-info-desc">
            一键就能把课程发布到所有平台，手机端即可完成操作
          </div>
          <img
            @click="freeUse"
            class="product-info-btn"
            src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home-btn.png"
          />
        </div>
      </div>
    </div>
    <div class="home-section home-section-2">
      <div class="home-header">私域流量裂变引擎：精准获客与高效促销</div>
      <div class="home-desc pt-25">
        全方位裂变引流与促销策略，精准获客促复购，私域流量疯狂增长
      </div>
      <div class="product-info-content-item home-layout">
        <div class="product-info-content-item-view">
          <div class="product-info-header">拉新获客</div>
          <div class="product-info-desc">
            多种裂变工具+超完整的分销系统，助你快速引流涨粉，通过现有用户的社交圈直接获取精准用户，搞定拉新难题。
          </div>
          <div class="product-info-header">营销工具</div>
          <div class="product-info-desc">
            多种营销工具：优惠券、限时抢购等，全方位满足你的促销需求，直接勾起用户的购买欲望，实现私域疯狂裂变。
          </div>
          <div class="product-info-header">留存复购</div>
          <div class="product-info-desc">
            赠课给好友、免费试看等功能，降低用户试错门槛，赢得用户信任，实现用户主动购买你的产品。
          </div>
          <img
            @click="freeUse"
            class="product-info-btn"
            src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home-btn.png"
          />
        </div>
        <img
          class="product-info-content-img"
          src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_section_2.png"
        />
      </div>
    </div>
    <div class="home-section home-section-3">
      <div class="home-header">“课程+圈子”，社群化学习模式提供进阶学习服务</div>
      <div class="home-desc pt-25">
        课程内嵌多互动功能，实现学员精细化运营与强链结私域效果
      </div>
      <div class="product-info-content-item home-layout">
        <img
          class="product-info-content-img"
          src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_section_3.png"
        />
        <div class="product-info-content-item-view">
          <div class="product-info-header">多终端专属学习圈子</div>
          <div class="product-info-desc">
            支持多终端四子，课程内嵌圈子实现多种互动能力，如动态分享小组学习积分排行等
          </div>
          <div class="product-info-header">精细化学员运营</div>
          <div class="product-info-desc">
            商家可对圈内学员进行多角色运营以实现精细化/强联结的私域运营效果
          </div>

          <img
            @click="freeUse"
            class="product-info-btn"
            src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home-btn.png"
          />
        </div>
      </div>
    </div>
    <div class="home-section home-section-4">
      <div class="home-header">双端数据监控，打造高效成交</div>
      <div class="home-desc pt-25">
        实时掌握用户状态，优化互动体验，飙升直播间成交率
      </div>
      <div class="product-info-content-item home-layout">
        <div class="product-info-content-item-view">
          <div class="product-info-header">数据实时查看</div>
          <div class="product-info-desc">
            支持PC端 +
            移动端双端实时查询粉丝增长，付费详情等关键数据，迅速掌握用户最新状态。
          </div>

          <div class="product-info-header">数据监控复盘</div>
          <div class="product-info-desc">
            自定义美颜 + 视频 /
            语音连麦，超低延迟打造极佳互动体验，有效提升直播间用户留存。
          </div>

          <div class="product-info-header">资金情况分析</div>
          <div class="product-info-desc">
            支持直播间课程、服务挂载售卖，结合直播秒杀、优惠券等玩法，快速提升用户购买欲望，实现直播间成交率飙升。
          </div>
          <img
            @click="freeUse"
            class="product-info-btn"
            src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home-btn.png"
          />
        </div>
        <img
          class="product-info-content-img"
          src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_section_4.png"
        />
      </div>
    </div>
    <div class="home-section home-section-5">
      <div class="home-header">卓越的教学平台，赢得讲师一致好评</div>
      <div class="home-desc pt-25">
        课程内容丰富精彩，获得师生的强烈推荐点赞
      </div>
      <div class="product-info-content-item home-layout">
        <img
          class="product-info-content-img"
          src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_section_5.png"
        />
        <div class="product-info-content-item-view">
          <div class="product-info-header">快速响应，解决燃眉之急</div>
          <div class="product-info-desc">
            设立24小时客服团队，确保讲师任何问题得到迅速响应。
          </div>

          <div class="product-info-header">个性化指导，满足多样化需求</div>
          <div class="product-info-desc">
            提供个性化的服务指导，从平台功能建议到课程内容优化，提供量身定制方案。
          </div>

          <div class="product-info-header">定期回访，持续优化服务</div>
          <div class="product-info-desc">
            建立定期回访机制，了解讲师体验和反馈意见，及时发现改进服务中的不足。
          </div>
          <img
            @click="freeUse"
            class="product-info-btn"
            src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home-btn.png"
          />
        </div>
      </div>
    </div>

    <div class="home-section home-section-2">
      <div class="home-header">知识数智化全渠道经营场景</div>
      <div class="home-desc pt-25">
        覆盖知识数智化全渠道经营场景，占据短视频公域流量入口，知识变现快速高效
      </div>
      <div class="home-scen" @click="freeUse"></div>
    </div>

    <!-- 系统支持 -->
    <div class="system-section">
      <div class="home-header white">
        强大的研发实力，安全稳定可靠的系统支持
      </div>
      <div class="home-desc white">
        来自互联网优秀的技术研发团队, 打造安全稳定可用的系统
      </div>
      <el-image
        class="system-image"
        src="https://image.renrenjiang.cn/domain_tools/website/icon_website_system_image.png"
      ></el-image>
    </div>

    <!-- 试用 -->
    <div class="try-section">
      <div class="home-header white">
        免费使用，零试错成本，为您的知识变现保驾护航
      </div>
      <div @click="freeUse" class="try-btn">立即试用</div>
    </div>

    <!-- 专业服务 -->
    <div class="service-section">
      <div class="home-layout">
        <div class="service-header">以用户为中心的专业服务</div>
        <div class="service-desc">用户为中心的服务，为讲师提供全方位服务</div>
        <div class="service-list">
          <div class="service-item">
            <img
              src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_serve_1.png"
            />
            <div class="service-content">
              <div class="service-title">专属客服</div>
              <div class="service-tip">专有客服协助上架</div>
            </div>
          </div>
          <div class="service-item">
            <img
              src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_serve_2.png"
            />
            <div class="service-content">
              <div class="service-title">运营指导</div>
              <div class="service-tip">专业诊断账号和运营建议</div>
              <!-- 运营 -->
            </div>
          </div>
          <div class="service-item">
            <img
              src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_serve_3.png"
            />
            <div class="service-content">
              <div class="service-title">专家服务</div>
              <div class="service-tip">可升级的专家服务</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 讲师入驻 -->
    <div class="teacher-section">
      <div class="home-header white">
        填写入驻信息，把握流量风口，实现全域变现
      </div>
      <div class="home-layout text-center teacher-apply-box">
        <input v-model="name" placeholder="请输入姓名" />
        <input v-model="phone" placeholder="请输入手机号" />
        <el-select
          class="teacher-select-channel"
          v-model="card_back"
          placeholder="您是从哪个渠道了解到我们的？"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <input
          v-if="card_back === '其他'"
          v-model="other_remark"
          placeholder="请输入不少于5个字的渠道信息"
        />
        <el-select
          v-if="card_back"
          class="teacher-select-channel"
          v-model="target_platform"
          placeholder="您要在哪个平台销售课程?"
        >
          <el-option
            v-for="item in channel"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-if="card_back"
          class="teacher-select-channel"
          v-model="used_online"
          placeholder="有没有线上课程"
        >
          <el-option label="有" value="有"></el-option>
          <el-option label="无" value="无"></el-option>
        </el-select>
        <!-- <el-select
          v-if="card_back"
          class="teacher-select-channel"
          v-model="used_radio_platform"
          placeholder="是否使用过其他卖课平台"
        >
          <el-option label="是" value="是"></el-option>
          <el-option label="否" value="否"></el-option>
        </el-select> -->
        <input
          v-if="used_online == '有'"
          v-model="used_platform"
          placeholder="卖课平台如：小鹅通、有赞、海豚"
        />
        <el-select
          v-if="used_online == '有'"
          class="teacher-select-channel"
          v-model="used_online_income"
          placeholder="线上收益"
        >
          <el-option label="有" value="有"></el-option>
          <el-option label="无" value="无"></el-option>
        </el-select>

        <div class="teacher-btn" @click="apply">立即入驻</div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="home-bottom">
      <div class="home-bottom-container">
        <div class="home-bottom-item">
          <div class="bottom-item-title">联系我们</div>
          <!-- <div class="bottom-item-text">
            <span>商务联系：</span>
            张老师：18034325093
          </div> -->
          <div class="bottom-item-text">
            <span>商务联系：</span>
            张老师：18395700692
          </div>
          <div class="bottom-item-text">
            <span class="text-transparent">商务联系：</span>
            樊老师：18610760713
          </div>
          <div class="bottom-item-text">
            <span>紧急联系：</span>
            赵老师：17160021706
          </div>
          <div class="bottom-item-text">
            <span>邮箱地址：</span>
            zhaojun@rayclear.com
          </div>
          <div class="bottom-item-text">
            <span>地址：</span>
            北京市海淀区上地六街17号1号楼2层6207号房间
          </div>
        </div>
        <div class="home-bottom-item">
          <div class="bottom-item-title">功能入口</div>
          <div class="bottom-item-text">
            <a
              target="_blank"
              href="https://html.renrenjiang.cn/document/index.html"
            >
              使用教程
            </a>
          </div>
          <div class="bottom-item-text">
            <a target="_blank" href="https://ke.renrenjiang.cn/#/course">
              学员听课入口
            </a>
          </div>
          <div class="bottom-item-text">
            <a target="_blank" href="https://dy.renrenjiang.cn/#/dashboard">
              讲师管理中心
            </a>
          </div>
          <div class="bottom-item-text">
            <a target="_blank" href="/#/download">官方下载</a>
          </div>
        </div>
        <div class="home-bottom-item">
          <div class="bottom-item-title">商务合作</div>
          <div class="bottom-item-imgs">
            <el-image
              class="bottom-item-qrcode"
              src="https://renrenjiang.cn/home/img/page/fan.png"
            ></el-image>
          </div>
        </div>
        <div class="home-bottom-item">
          <div class="bottom-item-title">官方客服</div>
          <el-image
            class="bottom-item-qrcode"
            src="https://image.renrenjiang.cn/teacher_center/website/icon_home_customer_qrcode.jpg?t=1"
          ></el-image>
        </div>
      </div>
      <div class="home-bottom-website">
        <div class="home-bottom-divider"></div>
        <div class="home-bottom-info">
          —— 人人讲·知识产品与用户服务的数字化工具 ——
        </div>
        <div class="home-bottom-info">
          Copyright © 2015-2025 北京云拓锐联科技有限公司 All Rights Reserved.
          <a target="_blank" href="https://beian.miit.gov.cn">
            京ICP备11005147号-14
          </a>
        </div>
        <div class="home-bottom-webicon">
          <div class="webicon-item">
            <el-image
              class="webicon-item-icon"
              fit="contain"
              src="https://image.renrenjiang.cn/teacher_center/douyin/icon_website_bottom_police.png"
            ></el-image>
            <div class="webicon-item-text">
              <a
                target="_blank"
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010702001942"
              >
                京公网安备 11010702001942号
              </a>
            </div>
          </div>
          <!-- <div class="webicon-item-divider"></div>
          <div class="webicon-item">
            <el-image
              class="webicon-item-icon"
              fit="contain"
              src="https://image.renrenjiang.cn/teacher_center/douyin/icon_website_bottom_network.png"
            ></el-image>
            <div class="webicon-item-text">京网文（2017）1627-154号</div>
          </div> -->
        </div>
        <el-image
          class="home-bottom-ssl"
          src="https://image.renrenjiang.cn/teacher_center/douyin/icon_website_ssl.jpg"
        ></el-image>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogFormVisible"
      width="601px"
      append-to-body
      custom-class="home-dialog"
      :close-on-click-modal="false"
    >
      <!-- <div class="dialog-head">
        <div class="dialog-head-title">添加专属顾问</div>
        <div class="dialog-head-close" @click="dialogFormVisible = false"></div>
      </div> -->
      <div class="dialog-body" @click="dialogFormVisible = false">
        <img
          class="success-dialog"
          src="https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/success-dialog.png?t=1"
        />
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button
          size="small"
          type="primary"
          @click="dialogFormVisible = false"
        >
          确 定
        </el-button>
      </div> -->
    </el-dialog>
  </div>
</template>
<script>
// 移动端跳转检测
var ua = window.navigator.userAgent;
if (/Android|iPhone|iPad/i.test(ua)) {
  window.location.href = "https://renrenjiang.cn/home/mobile.html";
}
import axios from "axios";
import CountTo from "vue-count-to";
// import { requestWebappAuth } from "@/api/im";
// import { visitorCreate } from "@/api/home";
export default {
  components: {
    CountTo,
  },
  data() {
    return {
      bannerIndex: 0,
      navFixed: false,
      numFixed: false,
      name: "",
      phone: "",
      card_back: "",
      other_remark: "",
      target_platform: "",
      used_radio_platform: "",
      used_platform: "",
      used_online: "",
      used_online_income: "",
      dialogFormVisible: false,

      options: [
        { value: "抖音", label: "抖音" },
        { value: "视频号", label: "视频号" },
        { value: "小红书", label: "小红书" },
        { value: "快手", label: "快手" },
        { value: "朋友/家人介绍", label: "朋友/家人介绍" },
        { value: "搜索引擎搜索", label: "搜索引擎搜索" },
        { value: "其他", label: "其他" },
      ],
      channel: [
        { value: "抖音", label: "抖音" },
        { value: "视频号", label: "视频号" },
        { value: "小红书", label: "小红书" },
        { value: "快手", label: "快手" },
      ],

      // techFixed: false,
      // coverIndex1: -1,
      // coverIndex2: -1,
      // coverIndex3: -1,

      demos: [
        {
          id: 1,
          nickname: "SOU-E",
          desc: "流行演唱高级讲师，玄动音乐-声乐指导兼歌手，东正音乐-御用歌手，网罗新声代(广州赛区)-声乐导师",
          avatar: "https://image.renrenjiang.cn/home/home_demo_5.png",
        },
        {
          id: 2,
          nickname: "宿耀文",
          desc: "首创简谱五线谱对照谱，让零基础学钢琴更简单，专注零基础学钢琴速成方法，20分钟即可弹奏一首钢琴曲",
          avatar: "https://image.renrenjiang.cn/home/home_demo_9.png",
        },
        {
          id: 3,
          nickname: "降央卓玛",
          desc: "中国藏族女歌手，2005年毕业于四川音乐学院。西藏音乐家协会副主席、理事、西藏文艺志愿者协会副主席",
          avatar: "https://image.renrenjiang.cn/home/home_demo_8.png",
        },
        {
          id: 4,
          nickname: "蔡仲杨",
          desc: "小红书摄影界头部达人，职业高级摄影师，单场活动变现突破万元，以卓越摄影技巧引领潮流，备受瞩目",
          avatar: "https://image.renrenjiang.cn/home/home_demo_1.png",
        },
        {
          id: 5,
          nickname: "何卷卷",
          desc: "抖音声乐头部讲师，以其独特的教学方法深受学员喜爱，帮助学员解锁悦耳歌喉，唱响音乐梦想",
          avatar: "https://image.renrenjiang.cn/home/home_demo_10.png",
        },
        {
          id: 11,
          nickname: "张博士解焦虑",
          desc: "协和医学院博士，20多年医学、心理学相关经验，牛津大学正念认知课程师资，麻省理工正念减压课程师资。",
          avatar: "https://image.renrenjiang.cn/home/home_demo_11.png",
        },
        {
          id: 6,
          nickname: "苦十八",
          desc: "抖音沙雕动画领域头部讲师，以幽默创意著称，擅长将生活点滴融入动画，传授动画制作技巧",
          avatar: "https://image.renrenjiang.cn/home/home_demo_6.png",
        },
        {
          id: 7,
          nickname: "猛男魔术师TonyChen",
          desc: "抖音魔术界明星讲师，融合力量与魔幻，传授魔术技巧，魔术行业的超级头部，变现天花板",
          avatar: "https://image.renrenjiang.cn/home/home_demo_7.png",
        },
        {
          id: 8,
          nickname: "阿豪象棋",
          desc: "抖音象棋领域顶尖达人，棋艺精湛，以独特视角解读棋局，分享象棋智慧，引领棋友共赏国粹之美",
          avatar: "https://image.renrenjiang.cn/home/home_demo_2.png",
        },
        {
          id: 9,
          nickname: "迈索尔优+瑜伽",
          desc: "专注教学数年，助力学员实现身心平衡。以专业引领，探索和谐身心之道，深受学员信赖与好评",
          avatar: "https://image.renrenjiang.cn/home/home_demo_4.png",
        },
        {
          id: 10,
          nickname: "艺生欧巴的声乐课",
          desc: "抖音声乐教学超级头部，分享专业技巧，传授发声秘籍，让每个人都能唱出动人歌声，点亮音乐梦想",
          avatar:
            "https://image.renrenjiang.cn/uploads/user/avatar_url/4529351/2021_e2472e9cee2be9510f47a9797972f3d4.png",
        },
        {
          id: 12,
          nickname: "张Sir教你升职加薪",
          desc: "职场教学头部达人，主导企业三年四倍速业绩增长，十年企业经营管理经验沉淀!",
          avatar: "https://image.renrenjiang.cn/home/home_demo_3.png",
        },
      ],
      // user: null,
    };
  },
  mounted() {
    this.user = this.$rrj.storage.get("_ukit");
    window.addEventListener("scroll", () => {
      console.log("scroll");
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 80) {
        this.navFixed = true;
      } else {
        this.navFixed = false;
      }

      if (scrollTop > 210 && scrollTop < 800) this.numFixed = true;
      else this.numFixed = false;

      // if (scrollTop > 1030 && this.coverIndex1 < 0) this.coverIndex1 = 0;
      // if (scrollTop > 1600 && this.coverIndex2 < 0) this.coverIndex2 = 0;
      // if (scrollTop > 2440 && this.coverIndex3 < 0) this.coverIndex3 = 0;
      // if (scrollTop > 4300 && scrollTop < 4900) this.techFixed = true;
      // else this.techFixed = false;

      // console.log("distance", scrollTop);
    });
    // this.checkCode();
  },
  methods: {
    changeBanner(index) {
      this.bannerIndex = index;
    },
    freeUse() {
      window.open("https://dy.renrenjiang.cn/#/login?from=homepage");
    },
    async apply() {
      if (!this.name.trim()) {
        this.$message.error("请输入姓名");
        return;
      }

      if (!this.phone.trim()) {
        this.$message.error("请输入手机号");
        return;
      }

      if (!this.card_back.trim()) {
        this.$message.error("请选择渠道");
        return;
      }

      if (this.card_back === "其他" && this.other_remark.length < 5) {
        this.$message.error("请输入不少于5个字的渠道信息");
        return;
      }

      if (!this.target_platform.trim()) {
        return this.$message.error("请选择您要在哪个平台销售课程");
      }
      // if (!this.used_radio_platform) {
      //   return this.$message.error("请选择您是否使用过其他平台");
      // }

      if (this.used_online === "有" && !this.used_platform.trim()) {
        return this.$message.error("请输入您用过的平台名称");
      }

      if (!this.used_online.trim()) {
        return this.$message.error("请选择有没有线上课程");
      }

      if (this.used_online === "无") {
        this.used_platform = "";
        this.used_online_income = "无";
      }

      if (!this.used_online_income.trim()) {
        return this.$message.error("请选择是否有收益");
      }

      const myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/.test(this.phone);
      if (!myreg) {
        this.$message({
          type: "error",
          message: "您输入的手机号码格式不正确",
        });
        return;
      }

      let text =
        this.card_back === "其他"
          ? this.card_back + "--" + this.other_remark
          : this.card_back;

      const formData = new FormData();
      // 添加文本字段
      formData.append("name", this.name);
      formData.append("phone", this.phone);
      formData.append("remark", "来源：" + text);
      formData.append("way", "人人讲官网");
      formData.append("target_platform", this.target_platform);
      formData.append("used_platform", this.used_platform);

      // 添加 extra 对象（JSON 字符串）
      formData.append(
        "extra",
        JSON.stringify({
          used_online: this.used_online,
          used_online_income: this.used_online_income,
        })
      );

      const res = await axios.post(
        "https://api.renrenjiang.cn/api/v3/teacher_hybrid/visitor_create",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置 Content-Type
          },
        }
      );

      console.log(res);
      this.dialogFormVisible = true;
    },
    // getPageParams() {
    //   let url = window.location.href;
    //   let param = {};
    //   url.replace(/([^?&]+)=([^?&]+)/g, function (s, v, k) {
    //     param[v] = decodeURIComponent(k); //解析字符为中文
    //     return k + "=" + v;
    //   });
    //   return param;
    // },
    // // 检测抖音Code
    // async checkCode() {
    //   let pageParams = this.getPageParams();
    //   let code = pageParams.code;
    //   let user = this.$rrj.storage.get("_ukit");
    //   if (code && user) {
    //     let res = await requestWebappAuth(code);
    //     console.log(res);
    //     if (res.result === "ok") {
    //       this.pageToLogin();
    //     }
    //   }
    // },
    // pageToLogin() {
    //   this.$router.push({
    //     name: "login",
    //   });
    // },
    // pageToSetting() {},
    // logout() {
    //   this.$store.dispatch("LogOut").then(() => {
    //     location.reload();
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}

.pt-25 {
  padding-top: 25px;
}

.pt-100 {
  padding-top: 100px;
}

.home-layout {
  // width: 1200px;
  width: 1200px;
  margin: 0 auto;
}

.home-banner {
  width: 100%;
  height: 493px;
  background: url("https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_banner.png")
    center center/100% 493px no-repeat;

  .home-layout {
    // position: relative;
    height: 493px;
  }

  position: relative;
  .home-banner-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    .home-banner-title {
      font-size: 50px;
      font-weight: 900;
      color: #3d3d3d;
      line-height: 78px;

      span:first-child {
        color: #126fff;
      }
    }

    .home-banner-tip {
      padding-top: 18px;
      font-size: 24px;
      color: #3d3b55;
    }
  }

  img {
    // width: 364px;
    width: 590px;
    // width: 30%;

    position: absolute;
    right: 0;
    bottom: 0;
    // margin-right: -130px;
  }
}

.home-banner-2 {
  background: url("https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_banner_bg.png")
    center center/100% 493px no-repeat;

  .home-banner-content {
    .home-banner-title {
      background: linear-gradient(
        to right,
        #f1af79 0%,
        #fff4ed 20%,
        #fff4ed 30%,
        #f1af79 80%,
        #f1af79 100%
      );
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent; /* 使文字颜色透明以显示背景渐变 */
    }
    .home-banner-tip {
      padding-bottom: 18px;

      background: url("https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_banner_tip_bg.png")
        left center/606px 54px no-repeat;

      span {
        background: linear-gradient(
          to right,
          #f1af79 0%,
          #fff4ed 20%,
          #fff4ed 30%,
          #f1af79 80%,
          #f1af79 100%
        );
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent; /* 使文字颜色透明以显示背景渐变 */
      }
    }
    .home-banner-info {
      span {
        background: linear-gradient(
          to right,
          #f1af79 0%,
          #fff4ed 20%,
          #fff4ed 30%,
          #f1af79 80%,
          #f1af79 100%
        );
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent; /* 使文字颜色透明以显示背景渐变 */
      }
      padding-top: 18px;
      font-size: 26px;
    }
  }
}

.home-banner-3 {
  background: url("https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_banner_bg2.png")
    center center/100% 493px no-repeat;
}

@media (max-width: 1210px) {
  .home-banner img {
    // width: 664px;
    width: 490px;
    // margin-right: 80px;
    right: -200px;
  }

  .home-banner-2 img {
    width: 390px;
    right: -200px;
  }

  .home-banner-3 img {
    width: 823.53px;
    height: 400px;
    margin-right: 0;
  }
}

@media (min-width: 1440px) {
  .home-banner img {
    // width: 664px;
    width: 590px;
    margin-right: 80px;
  }

  .home-banner-2 img {
    width: 490px;
    margin-right: 80px;
  }

  .home-banner-3 img {
    width: 823.53px;
    height: 400px;
    margin-right: 0;
  }
}

@media (min-width: 1610px) {
  .home-banner img {
    width: 664px;
    margin-right: 80px;
  }

  .home-banner-2 img {
    width: 500px;
    margin-right: 80px;
  }

  .home-banner-3 img {
    width: 823.53px;
    height: 400px;
    margin-right: 0;
  }
}

.home-header {
  font-size: 44px;
  font-weight: 900;
  text-align: center;
  color: #090909;
}

.home-desc {
  text-align: center;
  font-size: 28px;
  color: #686767;
}

.white {
  color: #fff;
}

// 工具
.home-tool-section {
  display: flex;
  justify-content: space-between;

  margin: 70px auto 50px;
  height: 129px;

  color: #090909;
  // font-size: 28px;
  font-size: 24px;

  .home-tool-item {
    display: flex;
    // width: 500px;
    width: 350px;
    height: 129px;
    align-items: center;

    background: #ebeffe;
    border-radius: 10px;
    padding: 0 15px;
    img {
      width: 85px;
      // width: 135px;
      // height: 129px;
    }
  }

  .home-tool-item-num {
    font-size: 48px;
  }
}

// 达人
.rotation-center {
  margin-top: 48px;
  width: 100%;
  overflow-x: hidden;
  position: relative;
  height: 870px;

  &::before {
    width: 169px;
    height: 224px;
    // height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    content: "";

    z-index: 10;

    left: 0;
    background: linear-gradient(270deg, rgba(247, 249, 251, 0) 0, #f7f9fb 100%);
  }

  &::after {
    width: 169px;
    height: 224px;
    position: absolute;
    top: 0;
    bottom: 0;
    content: "";

    z-index: 10;

    right: 0;
    background: linear-gradient(90deg, rgba(247, 249, 251, 0) 0, #f7f9fb 96%);
  }

  @keyframes toRight {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }

  ul {
    list-style-type: none;
    display: flex;

    flex-wrap: nowrap;

    justify-content: space-between;

    width: max-content;
    animation: toRight 36s linear infinite;
    animation-delay: 0;
  }

  li {
    margin-right: 20px;
  }

  img {
    width: 169px;
    height: 224px;
  }
}

.teacher-list {
  position: absolute;
  width: 1200px;
  // height: 618px;
  left: 50%;
  top: 180px;
  border-radius: 16px;
  padding: 30px 30px 15px;

  transform: translateX(-50%);

  // margin-top: 200px;

  box-sizing: border-box;

  border: 1px solid #f0f6ff;
  backdrop-filter: blur(5px);
  // background: #fff;
  // background: red;

  // opacity: 0.8;
  background-color: rgba(255, 255, 255, 0.8);

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: space-between;

  .teacher-item {
    text-align: center;
    // width: 216px;
    width: 173px;
    // height: 317px;
    padding-bottom: 10px;
    margin-bottom: 15px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 4px rgba(19, 33, 102, 0.05);
    overflow: hidden;
    cursor: pointer;
    background: #fff;
  }

  .teacher-item-img {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 106px;
    height: 106px;
    border: 1px solid #f0f6ff;
    border-radius: 50%;
    margin: 20px auto;
    img {
      width: 76px;
      height: 76px;
      border-radius: 50%;
      box-sizing: border-box;
      // border: 1px solid #a4c6ff;
    }
  }

  .demo-item-nickname {
    text-align: center;
    line-height: 44px;
    font-weight: 500;
    font-size: 16px;
  }

  .demo-item-desc {
    padding: 0 10px 0;
    line-height: 20px;
    font-size: 12px;
    color: #686767;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
}

// 全域支持
.home-channel {
  width: 100%;
  height: 437px;
  background: url("https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_channel.png")
    center center/1477px 437px no-repeat;
  margin-top: 50px;
  margin-bottom: 150px;
}

// 上架
.home-shelf {
  width: 100%;
  height: 524px;
  background: url("https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_shelf.png")
    center center/1477px 524px no-repeat;
  margin-top: 140px;
  margin-bottom: 90px;
}

.home-section {
  height: 870px;
  padding-top: 100px;
}

.home-section-1 {
  background: linear-gradient(292deg, #fafdff 0%, #f3f8ff 43%, #fcfeff 97%);
}

.home-section-2,
.home-section-4 {
  background: linear-gradient(246deg, #ffffff 2%, #eef2fd 49%, #fafdff 100%);
}

.home-section-3 {
  background: linear-gradient(248deg, #ffffff 2%, #f3f8ff 47%, #f4f7ff 98%);
}

.home-section-5 {
  background: linear-gradient(299deg, #ffffff 29%, #f3f8ff 59%, #f4f7ff 93%);
}

.product-info-content-item {
  display: flex;
  justify-content: space-between;
  margin-top: 75px;

  .product-info-content-img {
    width: 616px;
    height: 465px;
  }

  .product-info-content-item-view {
    display: flex;

    flex-direction: column;
    justify-content: center;
    // justify-content: space-around;

    width: 500px;
    height: 465px;
  }

  .product-info-header {
    padding-bottom: 10px;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    color: #090909;
  }

  .product-info-desc {
    font-size: 14px;
    line-height: 22px;
    color: #686767;
    margin-bottom: 35px;
  }

  .product-info-btn {
    display: block;
    width: 134px;
    height: 40px;
    cursor: pointer;
  }
}

.home-scen {
  width: 100%;
  height: 729px;
  background: url("https://renrenjiang.oss-cn-hangzhou.aliyuncs.com/home/home_scen.png")
    center center/1206px 729px no-repeat;
  margin-top: 0px;
  cursor: pointer;
}

// 系统支持
.system-section {
  width: 100%;
  height: 910px;
  padding-top: 120px;
  box-sizing: border-box;
  background-size: cover;
  background-image: url(https://image.renrenjiang.cn/domain_tools/website/icon_website_system_bg.jpg);

  display: flex;
  align-items: center;
  flex-direction: column;

  .system-image {
    width: 1180px;
    height: 499px;
    margin-top: 80px;
  }
}

// 试用
.try-section {
  width: 100%;
  height: 350px;
  padding-top: 100px;
  box-sizing: border-box;
  background-size: cover;
  background-image: url(https://image.renrenjiang.cn/domain_tools/website/icon_website_try_bg.jpg);

  display: flex;
  align-items: center;
  flex-direction: column;

  .try-btn {
    margin-top: 30px;
    border-radius: 4px;
    border: 1px solid rgba($color: #ffffff, $alpha: 0.6);
    padding: 0 30px;

    line-height: 42px;
    font-size: 16px;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background-color: #ffffff;
      color: #0366ff;
    }
  }
}

.service-section {
  width: 100%;
  height: 480px;

  background: #171b2a;
  .service-header {
    padding-top: 52px;
    font-size: 55px;
    font-weight: 900;
    background: linear-gradient(to right, #fcee7a 0%, #e098e3 30%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .service-desc {
    padding-bottom: 52px;
    padding-top: 22px;
    font-size: 25px;
    color: #d8d8d8;
  }

  .service-list {
    display: flex;
    justify-content: space-between;
  }

  .service-content {
    height: 80px;
  }

  .service-title {
    font-size: 30px;
    font-weight: 500;
    color: #ffffff;
  }

  .service-tip {
    font-size: 20px;
    font-weight: 500;
    color: #acacac;
    padding-top: 10px;
  }

  .service-item {
    display: flex;
    align-items: center;
    width: 380px;
    height: 160px;
    border-radius: 17px;
    padding: 0 20px;

    box-sizing: border-box;
    border: 1px solid rgba(255, 255, 255, 0.3);

    img {
      width: 85px;
      height: 75px;
      margin-right: 20px;
    }
  }
}

// 讲师
.teacher-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 400px;
  // padding-top: 89px;
  // padding-top: 50px;
  box-sizing: border-box;
  background-size: 100% 400px;
  background-repeat: no-repeat;
  background-color: linear-gradient(91deg, #376af5 2%, #376af5 99%);
  background-position: center;
  background-image: url(https://image.renrenjiang.cn/domain_tools/website/icon_website_try_bg.jpg);

  .teacher-apply-box {
    display: flex;
    margin-top: 67px;
    flex-flow: wrap;
  }

  input {
    box-sizing: border-box;

    // width: 252px;
    width: 252px;
    height: 55px;
    padding-left: 30px;
    border-radius: 133px;

    background: #ffffff;
    border: none;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;

    &::placeholder {
      color: #757575;
    }
  }

  // .el-select {
  //   // box-sizing: border-box;
  //   // margin-top: 67px;
  //   width: 252px;
  //   height: 55px;
  //   padding-left: 30px;
  //   // border-radius: 133px;

  //   // background: #ffffff;
  //   // border: none;
  //   margin-right: 20px;
  //   cursor: pointer;
  // }

  .teacher-btn {
    width: 252px;
    height: 55px;
    border-radius: 133px;

    /* 自动布局 */
    display: inline-flex;
    justify-content: center;
    align-items: center;

    background: #f3b249;

    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
    cursor: pointer;
  }
}

// 底部
.home-bottom {
  width: 100%;
  height: 575px;
  // margin-top: 110px;
  background-color: #171b2a;

  a {
    color: #d8d8d8;
  }

  .home-bottom-website {
    width: 1200px;
    margin: 0 auto;

    .home-bottom-divider {
      width: 100%;
      height: 1px;
      margin: 25px auto;
      background-color: rgba($color: #ffffff, $alpha: 0.2);
    }

    .home-bottom-info {
      width: 100%;
      margin-bottom: 10px;
      text-align: center;
      line-height: 20px;
      font-size: 12px;
      color: #d8d8d8;

      a {
        color: #d8d8d8;
      }
    }

    .home-bottom-ssl {
      margin: 10px auto;
      display: block;
      width: 200px;
      height: 62px;
    }

    .home-bottom-webicon {
      display: flex;
      align-items: center;
      justify-content: center;

      .webicon-item-divider {
        width: 1px;
        height: 12px;
        background-color: #d8d8d8;
      }

      .webicon-item {
        display: inline-flex;
        align-items: center;
        margin: 0 10px;

        .webicon-item-icon {
          width: 20px;
          height: 24px;
        }

        .webicon-item-text {
          margin-left: 5px;
          line-height: 20px;
          font-size: 12px;
          color: #d8d8d8;
        }
      }
    }
  }

  .home-bottom-container {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .home-bottom-item {
      padding-top: 50px;

      .bottom-item-title {
        margin-bottom: 25px;
        line-height: 40px;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
      }
      .bottom-item-text {
        margin-bottom: 15px;
        line-height: 20px;
        font-size: 14px;
        color: #d8d8d8;

        .text-transparent {
          color: transparent;
        }
      }

      .bottom-item-imgs {
        display: inline-flex;
        align-items: center;
      }

      .bottom-item-qrcode {
        width: 100px;
        height: 100px;
        margin-right: 10px;
      }
    }
  }
}

// header
.homepage-header {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 74px;
  /* position: relative; */
  position: absolute;
  top: 0;
  z-index: 1000;
  font-weight: 400;
  font-size: 16px;
  color: #333;
  line-height: 22px;
  // }

  /* .homepage-header > div{
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    } */

  .homepage-header-container {
    /* background-image: linear-gradient(-150deg, #FBFBFB 0%, #F5F5F5 100%); */
    /* transform: translateZ(0); */

    display: flex;
    align-items: center;
    justify-content: space-between;
    /* justify-content: space-around; */

    width: 1190px;
    height: 74px;
    z-index: 2;

    /* background: #F7F8FA; */
    /* background: red; */
  }

  /* .homepage-header-container::before {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        -webkit-backdrop-filter: blur(20px);
        backdrop-filter: blur(20px);
        z-index: -1;
      } */

  &.fixed {
    animation: fadeIn 0.6s;
    min-width: 990px;
    position: fixed;
    top: 0;
    /* width: 1190px; */
    width: 100%;
    /* -webkit-backdrop-filter: blur(20px);
      backdrop-filter: blur(20px); */
    /* background-color: #1452de; */
    background-color: #fff;
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.2);
    color: #333;
    z-index: 99;
  }

  // .homepage-header.fixed .homepage-header-nav-item {
  //   color: #333;
  // }

  // .homepage-header .logo1 {
  //   display: block;
  // }

  // .homepage-header .logo2 {
  //   display: none;
  // }

  // .homepage-header.fixed .logo1 {
  //   display: none;
  // }

  // .homepage-header.fixed .logo2 {
  //   display: block;
  // }

  /*
    .homepage-header-container.fixed::before {

      content: "";
      opacity: .8;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: -1;
      -webkit-backdrop-filter: blur(20px);
      backdrop-filter: blur(20px);
    } */

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .homepage-header-logo {
    align-items: center;
    display: flex;
    width: 142px;
    height: 74px;
    margin-right: 45px;
    /* background-color: red; */
  }

  .homepage-header-logo--logo {
    /* box-shadow: 0 4px 7px 0 rgba(97, 51, 51, 0.2); */
    /* border-radius: 6px; */
    height: 74px;
    width: 142px;
  }

  .homepage-header-logo--text {
    margin-left: 10px;
    height: 24px;
    width: 70px;
  }

  .homepage-header-left {
    display: flex;
    align-items: center;
  }

  .homepage-header-right {
    align-items: center;
    align-self: stretch;
    display: flex;
    /* justify-content: space-between; */
    position: relative;
    /* width: 720px; */
  }

  .homepage-header-top-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 98px;
    height: 36px;
    background: #ffffff;
    border-radius: 728px 728px 728px 728px;
    margin-left: 10px;
  }

  .homepage-header-top-teacher-btn {
    background: #ffffff;
    font-weight: 600;
    font-size: 14px;
    color: #1452de;
  }

  .homepage-header-top-open-btn {
    font-weight: 600;
    font-size: 14px;
    color: #ffffff;
    background: linear-gradient(270deg, #f7bd5c 0%, #fc8a4a 100%);
  }

  .homepage-header.fixed .homepage-header-top-teacher-btn {
    background: #ffffff;
    font-weight: 600;
    font-size: 14px;
    color: #1452de;
    border: 1px solid #1452de;
  }

  .homepage-header-nav {
    display: flex;
    /* justify-content: space-between;
        width: 540px; */
  }

  .homepage-header-nav-item {
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    color: #333;
    line-height: 22px;
    margin-right: 45px;
  }

  .homepage-header-nav--white .homepage-header-nav-item {
    color: #fff;
    transition: all 0.3s ease-in-out;
  }

  // .homepage-header-nav-item.active {
  //   /* color: #353230; */
  //   /* font-family: SourceHanSansCN-Heavy; */
  //   /* font-size: 18px;
  //         font-weight: bold;
  //         line-height: 27px; */
  //   font-weight: 400;
  //   font-size: 16px;
  //   color: #333;
  //   line-height: 22px;
  // }
}
</style>

<style lang="scss">
.home-dialog {
  background: transparent;
  .success-dialog {
    width: 601px;
    height: 559px;
  }

  .dialog-body {
    background: transparent;
  }
}

.teacher-select-channel {
  margin-right: 20px;
  margin-bottom: 20px;
}

.teacher-select-channel input {
  box-sizing: border-box;
  // margin-top: 67px;
  width: 252px;
  height: 55px;
  padding-left: 30px;
  border-radius: 133px;
  background: #ffffff;
  border: none;
  // margin-right: 20px;
  cursor: pointer;

  &::placeholder {
    color: #757575;
  }
}
</style>
